import { hasDocumentSigning } from '../modules/document-signing/index.js';
// Every rule deciding whether documents of a type get signed. The admin form, request validation
// and the API all ask this, so changing a rule here changes it everywhere.
export class DocumentTypeSignatureRules {
    config;
    static OFFICIAL_ONLY = 'Only Official Documents can require signatures';
    constructor(config) {
        this.config = config;
    }
    // Signing ends by publishing the signed copy to the portal, and only official documents publish.
    canRequireSignature() {
        return this.config.isPublic;
    }
    // An unofficial type never requires signatures; its signers are kept for when it's official again.
    requiresSignature() {
        return this.canRequireSignature() && this.config.requiresSignature === true;
    }
    isMissingSigners() {
        const { signers } = this.config;
        return this.requiresSignature() && !(Array.isArray(signers) && signers.length > 0);
    }
    // Switching signing on needs the signing module. A type that already requires signatures keeps
    // them, so losing the module never locks the type against edits.
    needsSigningModule(previously) {
        return (this.requiresSignature() &&
            !(previously && new DocumentTypeSignatureRules(previously).requiresSignature()));
    }
    // Signers only take effect while the government has the signing module.
    isInEffectFor(government) {
        return this.requiresSignature() && hasDocumentSigning(government);
    }
}
